import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Colors } from 'constants/colors'
import PropTypes from 'prop-types'
import { IconButton, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

export const EditActionButton = ({ value }) => {
  const { t } = useTranslation()

  return (
    <Tooltip title={t('edit')}>
      <IconButton size="small" LinkComponent={Link} target="_blank" to={`/product/edit/${value}`}>
        <FontAwesomeIcon icon={['fas', 'pen-to-square']} color={Colors.MAROON} size="sm" />
      </IconButton>
    </Tooltip>
  )
}

EditActionButton.propTypes = {
  value: PropTypes.string,
}
